import { useLoaderData } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";
import MansionFields from "./MansionFields";

export default function EditMansion() {
  const data = useLoaderData();
  const loadFn = (form) =>
    form.setFieldsValue({
      id: data.id,
      name: data.name,
      requiredCourseTypes: (data.requiredCourseTypes ?? []).map((course) => course.id),
      requiredDpis: (data.requiredDpis ?? []).map((dpi) => dpi.id),
    });

  return (
    <SimpleFormPage title="Modifica mansione" loadFn={loadFn}>
      <MansionFields editing />
    </SimpleFormPage>
  );
}
